import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { SegurosWPService } from 'src/app/core/http/web/segurosWp.service';
import { environment as params } from 'src/environments/environment';
import { SlickDirective } from 'src/app/core/directives/slick.directive';

@Component({
  selector: 'app-proxima-aventura',
  templateUrl: './proxima-aventura.component.html',
  styleUrls: ['./proxima-aventura.component.scss']
})
export class ProximaAventuraComponent implements OnInit {
  @ViewChild(SlickDirective) slickDirective: SlickDirective;
  @Input('load_serv') public load_serv: boolean = true;
  @Input('data') public data: any = null;
  public loadings: any;
  public errors: any;
  public urlBaseS3: any = (<any>params).api.s3;
  public slickOptions: any = {
    responsive: [
      {
        breakpoint: 15768,
        settings: {
          slidesToShow: 3
        }
      }
    ],
    autoplaySpeed: 5000,
  };
  public slickOptionsMb: any = {
    responsive: [
      {
        breakpoint: 15768,
        settings: {
          slidesToShow: 1
        }
      }
    ],
    autoplaySpeed: 5000,
  };
  constructor(
    private segWpServ: SegurosWPService
  ) { }

  ngOnInit() {
    if (this.load_serv) {
      this.getDataServ();
    }
  }
  getDataServ() {
    this.segWpServ.getDataRecomendaciones().subscribe(data => {
      this.data = data;
      this.loadings = false;
    }, err => {
      console.error('Error | getDataAllSeguros: ', err);
      this.errors = err;
    });
  }

  // reload() {
  //   this.loadings = true;
  // }

  /**
   * slide siguiente
   */
  next() {
    this.slickDirective.next();
  }

  /**
   * slide anterior
   */
  prev() {
    this.slickDirective.prev();
  }

}
